import './Header.css'
import kriyago_logo from '../../images/kriyago_logo.png'
import concur_logo from '../../images/concur_logo.png'

function Header() {
    return (
        <div>
            <div className="header">
                <img src={kriyago_logo} className="kriyago-logo" alt="kriyago-logo" />
                <img src={concur_logo} className="concur-logo" alt="concur-logo" />
            </div>
        </div>
    );
  }
  
  export default Header;